module.exports = __webpack_public_path__ + "static/img/2025IplPop.6fd2caa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/2025IplPop.webp
// module id = I7QZ
// module chunks = 0